import { CampaignStatus } from 'generated-graphql/graphql';
import { CampaignStatus as DeprecatedCampaignStatus } from 'services/campaign/types';

export const getCampaignStatusLabel = (
  status: CampaignStatus | DeprecatedCampaignStatus
): string => {
  switch (status) {
    case DeprecatedCampaignStatus.DRAFT:
      return 'Draft';
    case DeprecatedCampaignStatus.SCHEDULED:
      return 'Scheduled';
    case DeprecatedCampaignStatus.SENDING_MESSAGES:
      return 'Sending';
    case DeprecatedCampaignStatus.GENERATING_MESSAGES:
      return 'Generating messages';
    case DeprecatedCampaignStatus.FINISHED_GENERATING:
      return 'Ready for launch';
    case DeprecatedCampaignStatus.FINISHED_SENDING:
    case DeprecatedCampaignStatus.LIVE:
      return 'Live';
    case DeprecatedCampaignStatus.DISCONNECTED:
      return 'Disconnected';
    case DeprecatedCampaignStatus.ARCHIVED:
      return 'Archived';
    default:
      return 'Loading';
  }
};
